// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bf58","toggleWrap":"styles_toggleWrap__2Pjtt","content":"styles_content__pBUhx","selectAreaCode":"styles_selectAreaCode__2b9hS"};